import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppModeService } from 'src/app/services/app-mode.service';

type SupportedLangCode = 'en' | 'fr' | 'ar';

@Component({
  selector: 'app-choose-language',
  templateUrl: './choose-language.component.html',
  styleUrls: ['./choose-language.component.css'],
})
export class ChooseLanguageComponent implements OnInit {
  languages: ReadonlyArray<{
    code: SupportedLangCode;
    labelKey: string;
    flagClass: string;
  }> = [
    { code: 'en', labelKey: 'CHOOSE_LANGUAGE.LANG_EN', flagClass: 'fi-gb' },
    { code: 'fr', labelKey: 'CHOOSE_LANGUAGE.LANG_FR', flagClass: 'fi-fr' },
    { code: 'ar', labelKey: 'CHOOSE_LANGUAGE.LANG_AR', flagClass: 'fi-sa' },
  ];

  selectedLang = 'en';
  currentLang = 'en';
  isMobileApp = false;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly appModeService: AppModeService
  ) {}

  ngOnInit(): void {
    this.currentLang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.selectedLang = localStorage.getItem('lang') || 'en';
    this.isMobileApp = this.appModeService.isApp();

    if (!this.isMobileApp) {
      this.router.navigateByUrl(`/${this.currentLang}/profile`);
    }
  }

  selectLang(code: string): void {
    this.selectedLang = code;
  }

  onContinue(): void {
    this.translate.use(this.selectedLang);
    localStorage.setItem('lang', this.selectedLang);
    this.router.navigateByUrl(`/${this.selectedLang}/home`);
    setTimeout(() => {
      window.location.reload();
    });
  }

  goBack(): void {
    this.router.navigateByUrl(`/${this.currentLang}/profile`);
  }
}
